import React from 'react';
import { motion } from 'framer-motion';
import { Header } from './components/Header';
import { FounderProfile } from './components/FounderProfile';
import { ProblemSection } from './components/ProblemSection';
import { VisionSection } from './components/VisionSection';
import { FinancialsSection } from './components/FinancialsSection';
import { WhyMeSection } from './components/WhyMeSection';
import { TheAskSection } from './components/TheAskSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 pb-24" data-id="element-2">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8
      }} className="space-y-20 pt-32" data-id="element-3">
          <FounderProfile data-id="element-4" />
          <ProblemSection data-id="element-5" />
          <VisionSection data-id="element-6" />
          <FinancialsSection data-id="element-7" />
          <WhyMeSection data-id="element-8" />
          <TheAskSection data-id="element-9" />
          <FinalCTASection data-id="element-10" />
        </motion.div>
      </main>
    </div>;
}